import { Calculator } from "../common/calculator";
import { Field } from "../common/basic_fields.js";

class LNTCalculator extends Calculator {
    code() { return "lnt"; }
    type() { return "CalcLandTax"; }

    initialize() {
        let self = this;
        this.patchFieldTypes([ShareField]);
        this.setupStatistic({
            calcName: 'land_tax'
        });

        // add input fields
        this.addInputField('#cadastreValueInput input', 'cadastreValue', {
            type: 'money', options: { maxVal: 999999999999.99 },
            errors: [{ check: function (v) { return !!v; }, selector: '#cadastreValueInput .error-text' }]
        });
        this.addInputField('#shareInput input', 'share', {
            type: 'share',
            errors: [
                { check: function (v) { return !!v; }, selector: '#shareInput .null-error' },
                { check: function (v) { return !(v && v.isError); }, selector: '#shareInput .wrong-error' }
            ]
        });
        this.addInputField('#taxRateInput input', 'taxRate', {
            type: 'float', options: { precision: 4 },
            errors: [
                { check: function (v) { return !!v; }, selector: '#taxRateInput .null-error' },
                { check: function (v) { return !(v && ((v < 0.01) || (v > 1.5))); }, selector: '#taxRateInput .wrong-error' }
            ]
        });
        this.exemptionField = this.addInputField('#exemptionInput .base-input', 'exemption', {
            type: 'float', options: { precision: 4, maxVal: 100 }
        });
        this.increaseCoefField = this.addInputField("#increaseCoefInput dropdown-select", 'increaseCoef');
        this.extraTaxDeductionField = this.addInputField('#extraTaxDeductionInput .base-input', 'extraTaxDeduction', {
            type: 'float', options: { precision: 4, maxVal: 100 }
        });
        this.cadastreAreaField = this.addInputField('#cadastreAreaInput input', 'cadastreArea', {
            type: 'float', options: { precision: 2 },
            errors: [{ check: function (v) { return !!v; }, selector: '#cadastreAreaInput .error-text' }]
        });

        // add output fields
        this.addOutputField('.tax-rate-render', 'taxRate', { type: 'percent', minPrecision: 0, maxPrecision: 4 });
        this.addOutputField('.exemption-render', 'exemption', { type: 'percent', minPrecision: 0, maxPrecision: 4 });
        this.addOutputField('.extra-tax-deduction-render', 'extraTaxDeduction', { type: 'percent', minPrecision: 0, maxPrecision: 4 });
        this.addOutputField('.cadastre-area-render', 'cadastreArea', { type: 'area', render: function (r) { return tools.getLocaleNumber(r) + ' кв. м' } });
        this.addOutputField('.extra-tax-deduction-meter-render', 'extraTaxDeductionMeter', { type: 'area', render: function (r) { return tools.getLocaleNumber(r) + ' кв. м' } });
        this.addOutputField('.share-render', 'share', { type: 'share', render: function (r) { return r.text.trim() } });

        this.addOutputField('.cadastre-area-block', '', {
            type: 'toggle', render: function () {
                return self.cadastreArea && self.cadastreArea > 0 &&
                    (self.isTaxDeduction || (self.isExtraTaxDeduction && self.extraTaxDeduction && self.extraTaxDeduction > 0))
            }
        });
        this.addOutputField('.increase-coef-block', '', { type: 'toggle', render: function () { return self.isIncreaseCoef } });
        this.addOutputField('.exemption-block', '', { type: 'toggle', render: function () { return self.isExemption && self.exemption && self.exemption > 0 } });
        this.addOutputField('.tax-deduction-block', '', { type: 'toggle', render: function () { return self.isTaxDeduction && self.cadastreArea && self.cadastreArea > 0 } });
        this.addOutputField('.extra-tax-deduction-block', '', { type: 'toggle', render: function () { return self.isExtraTaxDeduction && self.extraTaxDeduction && self.extraTaxDeduction > 0 && self.cadastreArea && self.cadastreArea > 0 } });

        this.loadDescription();

        this.cadastreAreaField.ignore = true;

        this.submitOnClick('#calcSubmit');
        this.addResetButton("#clearCalcInput");
    }

    onReset() {
        $('.calc-div-results').removeClass('show-results');

        $('#exemptionInput .field-div').addClass('hidden-control');
        $('#increaseCoefInput .field-div').addClass('hidden-control');
        $('#increaseCoefInput .field-div').addClass('hidden-control');
        $('#extraTaxDeductionInput .field-div').addClass('hidden-control');
        $('#cadastreAreaInput').addClass('hidden-control');

        this.cadastreAreaField.ignore = true;
    }


    generateExportObject() {
        let result = super.generateExportObject();
        result.taxSum = this.taxSum;
        result.share = this.share.text.replace('&nbsp;', ' ');
        result.taxRate = this.taxRate;
        result.extraTaxDeduction = this.extraTaxDeduction;
        result.exemption = this.exemption;
        result.cadastreArea = this.cadastreArea;
        
        return result;
    }

    showResults() {
        super.showResults();

        var goalParams = {
            args: {
                Ukaz_lgot_land: this.isExemption,
                Lgot_land: this.isExemption ? this.exemption : null,
                Ukaz_povish_koef_land: this.isIncreaseCoef,
                Ukaz_nalog_vich_land: this.isTaxDeduction,
                Ukaz_dop_nalog_vich_lang: this.isExtraTaxDeduction,
                Dop_nalog_vich_lang: this.isExtraTaxDeduction ? this.extraTaxDeduction : null,
                Dolya_land: this.share.text === "100%" ? false : true,
                Stavka_zemel: this.taxRate
            },
            message: 'Is_Made'
        };
        this.sendStatisticMessage(goalParams);
    }

    afterParse(sender, autoValidation) {
        let self = this;
        let $elem = $(sender);
        let $exemptionCheckbox = $("#exemptionInput .checkboxrow");
        let $increaseCoefCheckbox = $("#increaseCoefInput .checkboxrow");
        let $taxDeductionCheckbox = $("#taxDeductionInput");
        let $extraTaxDeductionInput = $("#extraTaxDeductionInput .base-input");
        let $extraTaxDeductionCheckbox = $("#extraTaxDeductionInput .checkboxrow");
        let $cadastreAreaInput = $("#cadastreAreaInput");

        if ($elem.is($exemptionCheckbox) || $elem.is($increaseCoefCheckbox) || $elem.is($extraTaxDeductionCheckbox) || $elem.is($taxDeductionCheckbox)) {
            if ($elem.is($taxDeductionCheckbox) || $elem.is($extraTaxDeductionCheckbox)) {
                if (this.isTaxDeduction || this.isExtraTaxDeduction) {
                    $cadastreAreaInput.removeClass('hidden-control');
                    if (this.isTaxDeduction || (this.isExtraTaxDeduction && this.extraTaxDeduction)) {
                        this.cadastreAreaField.ignore = false;
                    } else {
                        this.cadastreAreaField.ignore = true;
                    }
                } else {
                    $cadastreAreaInput.addClass('hidden-control');
                    this.cadastreAreaField.ignore = true;
                }
            }

            var $checkboxInput = $elem.parents('div .edge-padding').eq(0);
            var $inputField = $checkboxInput.find('.field-div');
            if ($elem.find('input').is(':checked')) {
                $inputField.removeClass('hidden-control');

                if ($elem.is($extraTaxDeductionCheckbox) || $elem.is($exemptionCheckbox)) {
                    var $input = $inputField.find('input');
                    if ($input) {
                        $input.focus();
                        $input.select();
                    }
                }
            }
            else {
                $inputField.addClass('hidden-control');
            }
        } else if ($elem.is($extraTaxDeductionInput)) {
            if ((this.isExtraTaxDeduction && this.extraTaxDeduction) || this.isTaxDeduction) {
                this.cadastreAreaField.ignore = false;
            } else {
                this.cadastreAreaField.ignore = true;
            }
        }
    }

    calculate(params) {
        if (params.autoValidation) {
            return false;
        }

        let self = this;

        var share = this.share.value;
        if (this.cadastreArea && this.cadastreArea > 0 &&
            (this.isTaxDeduction || (this.isExtraTaxDeduction && this.extraTaxDeduction && this.extraTaxDeduction > 0))) {

            share = this.cadastreArea * this.share.value;

            if (this.isTaxDeduction) {
                share = share - 600;
            }

            if (this.isExtraTaxDeduction) {
                self.extraTaxDeductionMeter = this.cadastreArea * this.extraTaxDeduction / 100;
                share = share - self.extraTaxDeductionMeter;
            }
            share /= this.cadastreArea;
        }

        if (share < 0) {
            self.taxSum = 0;
        } else {
            var taxSum = this.cadastreValue * (this.taxRate / 100) * (this.period.value / 12) * share;

            if (this.isExemption && this.exemption && this.exemption > 0) {
                taxSum = taxSum * (1 - this.exemption / 100);
            }

            if (this.isIncreaseCoef) {
                taxSum = taxSum * this.increaseCoef.value;
            }

            self.taxSum = Math.round(taxSum);
        }

        return true;
    }
}

class ShareField extends Field {
    static keyName() { return 'share'; }
    getValue() {
        if (!Number.parseInt) {
            Number.parseInt = window.parseInt
        }

        var result = {};
        result.text = this.elem.val();
        result.value = undefined;
        result.isError = false;

        if (!result.text) {
            return null;
        } else if (result.text.indexOf('/') !== -1) {
            var array = result.text.split('/');
            var divident = parseInt(array[0], 10);
            var divider = array[1] !== '' ? parseInt(array[1], 10) : null;

            if (divider === null) {
                result.value = 1;
                result.text = divident.toString();
            } else {
                result.value = divident / divider;
                result.text = divident.toString() + '/' + divider.toString();
            }

            if (!divident || !divider || divident > divider) {
                result.isError = true;
            }
        } else if ((result.text.indexOf('.') !== -1 || result.text.indexOf(',') !== -1) && result.text.indexOf('%') === -1) {
            var floatNum = tools.parseLocaleFloat(result.text);

            result.value = floatNum;
            result.text = tools.getLocaleNumber(floatNum).toString();

            if (result.value === undefined || result.value > 1.0) {
                result.isError = true;
            }
        } else if (result.text.indexOf('%') !== -1) {
            var arr = result.text.split('%');
            var percentNum = tools.parseLocaleFloat(arr[0].replace(/\s+/g, ''));

            result.value = percentNum / 100;
            result.text = tools.getLocaleNumber(percentNum).toString() + '%';
            
            if (!percentNum || percentNum > 100) {
                result.isError = true;
            }
        } else {
            result.value = parseInt(result.text, 10);
            result.text = result.value.toString();

            if (result.value === 0) {
                return null;
            }
            else if (result.value !== 1) {
                result.isError = true;
            }
        }
        this.elem.val(result.text);

        return result;
    }
    getClearValue() { return this.getValue() ? this.getValue().text : null; }
    setValue(v) { this.elem.val(v); }
    init() {
        $.fn.shareFilter = function () {
            return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
                var newSelectionStart = this.selectionStart;
                var newSelectionEnd = this.selectionEnd;

                var simpleVal = this.value.replace(/[^\dр.,\/юб%]/g, '')
                    .replace(/[р,\юб]/g, '.') // replace all separators with dot
                    .replace(/\.+/g, '.').replace('.', ',').replace(/\./g, '') // remove doubled dots, leave first dot (comma) only
                    .replace(/\/+/g, '/')
                    .replace(/\%+/g, '%')
                    .replace(/^0+/, '0'); // remove leading zeros

                if (simpleVal[0] === ',') {
                    simpleVal = '0' + simpleVal;
                }
                else if (simpleVal[0] === '/') {
                    simpleVal = '1' + simpleVal;
                }

                var lastSymbol = simpleVal.slice(-1);
                var penultSymbol = simpleVal[simpleVal.length - 2];
                var croppedVal = simpleVal.slice(0, -1);

                if (lastSymbol === '/' && (croppedVal.indexOf('/') !== -1 || croppedVal.indexOf('%') !== -1 || croppedVal.indexOf(',') !== -1)) {
                    simpleVal = croppedVal;
                }
                else if (lastSymbol === '%' && (croppedVal.indexOf('/') !== -1 || croppedVal.indexOf('%') !== -1)) {
                    simpleVal = croppedVal;
                }
                else if (lastSymbol === ',' && (croppedVal.indexOf('/') !== -1 || croppedVal.indexOf('%') !== -1)) {
                    simpleVal = croppedVal;
                }

                if (penultSymbol === '%') {
                    simpleVal = croppedVal;
                }

                this.value = simpleVal;
            });
        };

        this.elem.focusin(function () {
            var $field = $(this).closest('div.field-div');
            this.classList.remove('err');
            $field.find(".error-text").hide();
            $field.find("input").shareFilter();
        });
    }
}

$(function () {
    var calc = new LNTCalculator();
});